<template>
  <target-data
    v-if="currentTarget !== null"
    ref="target"
    :session-program="sessionProgram"
    :target="currentTarget"
    :data="data"
    :active-prompt-levels="activePromptLevels"
    :dense="dense"
    :tiny="tiny"
    :focused="focused"
    :disable="isDisabled"
    :workflow-statuses="workflowStatuses"
    :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
    @record-program-data="onRecordProgramData"
    @record="onRecordData"
  />
</template>
<script>
import { chain, get } from 'lodash';
import DataCollection from 'src/mixins/DataCollection';
import { defineAsyncComponent } from 'vue';

export default {

  name: 'RandomRotationTarget',

  components: { TargetData: defineAsyncComponent(() => import('components/Programs/DataCollection/TargetData')) },

  mixins: [DataCollection],

  // Even though this function doesn't emit 'record' it is required to be here
  // to make sure we break the emit-chain and don't emit 'record' from the
  // TargetData component.
  emits: ['record-program-data', 'record-target', 'record'],

  data() {
    return {

    };
  },

  computed: {

    nextTrial() {
      return chain(this.data)
        .get('data')
        .maxBy('trial')
        .get('trial', 0)
        .add(1)
        .value();
    }, // nextTrial()

    currentTarget() {
      if (!get(this.target, 'id')) {
        return null;
      }
      return chain(this.target)
        .get('subTargets', [])
        .find({ id: get(this.data, `rrTarget_${this.target.id}`, null) })
        .defaultTo(null)
        .value();
    },

  },

  methods: {

    onRecordProgramData(sessionProgram, dataObj) {
      this.$emit('record-program-data', sessionProgram, dataObj);
    }, // onRecordProgramData()

    finishSession() {
      if (chain(this.$refs).get(['target', 'finishSession']).isFunction().value()) {
        return this.$refs.target.finishSession();
      }
    },

    onRecordData(sessionProgram, target, data) {
      // Set defaults
      const trial = this.nextTrial;

      const saveData = { ...data, trial };
      this.$emit('record-target', target, saveData);
    }, // onRecordData()

  },
};
</script>
